import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'

import * as GmapVue from 'gmap-vue'

Vue.config.productionTip = false

Vue.use(GmapVue, {
  load: {
    key: 'AIzaSyBXHTApQxC7eBOhAUSi5kiniwnOdztCyKY',
    libraries: 'geometry'
  },
  installComponents: true
})

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
